import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { QuotesComponent } from './quotes.component';
import { QuotesRoutingModule } from './quotes-routing.module';
import { QuotesFormComponent } from './quotes-form/quotes-form.component';

@NgModule({
  declarations: [QuotesComponent, QuotesFormComponent],
  imports: [
    SharedModule,
    QuotesRoutingModule
  ]
})
export class QuotesModule { }
